import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { PERSONAL_DETAIL, PERSONAL_DETAIL_SUCCESS, PERSONAL_DETAIL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getPersonalDetail({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/details`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: PERSONAL_DETAIL_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: PERSONAL_DETAIL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PERSONAL_DETAIL_ERROR, payload: error });
  }
}

export function* watchPersonalDetail() {
  yield takeEvery(PERSONAL_DETAIL, getPersonalDetail);
}

function* watchPersonalDetailSaga() {
  yield all([fork(watchPersonalDetail)]);
}

export default watchPersonalDetailSaga;
